var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 415.472,
    x2: 96.528,
    y1: 483.75,
    y2: 28.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#32b0c4",
    offset: 0.101
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#3fe398",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M104.621 419.794v56.262c0 14.821 13.108 26.943 29.132 26.943h244.494c16.024 0 29.132-12.122 29.132-26.943v-56.262zM407.379 35.943C407.379 21.122 394.271 9 378.247 9H133.753c-16.024 0-29.132 12.122-29.132 26.943v23.535h302.758zm-172.626 6.296a8 8 0 0 1 0-16h42.494a8 8 0 0 1 0 16zm-130.132 33.24v328.316h302.758V75.479zM248 330.763v-22.41h-73.076v22.41c7.336 3.116 12.481 10.386 12.481 18.859 0 11.311-9.17 20.481-20.481 20.481s-20.481-9.169-20.481-20.481c0-8.473 5.145-15.743 12.481-18.859v-30.41a8 8 0 0 1 8-8H248v-24.507h-56.748c-27.946 0-50.81-22.864-50.81-50.809 0-24.824 18.215-46.187 42.707-50.156-.002-.218-.008-.435-.008-.654 0-31.512 25.545-57.057 57.057-57.057 18.934 0 35.71 9.225 46.089 23.422a30.554 30.554 0 0 1 17.298-5.336c16.954 0 30.698 13.744 30.698 30.698 0 3.393-.552 6.657-1.568 9.709 22.222 5.416 38.846 25.546 38.846 49.374 0 27.945-22.865 50.81-50.81 50.81H264v24.507h81.076a8 8 0 0 1 8 8v30.41c7.336 3.116 12.481 10.386 12.481 18.859 0 11.311-9.169 20.481-20.481 20.481-11.311 0-20.481-9.169-20.481-20.481 0-8.473 5.145-15.744 12.481-18.859v-22.41H264v22.41c7.336 3.116 12.481 10.386 12.481 18.859 0 11.311-9.169 20.481-20.481 20.481-11.311 0-20.481-9.169-20.481-20.481 0-8.473 5.145-15.744 12.481-18.86zm24.594 116.427c7.814 0 14.207 6.393 14.207 14.207s-6.393 14.208-14.207 14.208h-33.189c-7.814 0-14.208-6.393-14.208-14.208 0-7.814 6.393-14.207 14.208-14.207z",
    clipRule: "evenodd",
    "data-original": "url(#a)",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDown);
export default __webpack_public_path__ + "static/media/appDown.7168316ffc81b96d9a8eb5f6d2b27bba.svg";
export { ForwardRef as ReactComponent };